import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { mixpanelEvents, useTrackEvent } from '../../utils/mixpanel';
import { makeAPIRequestReactQuery } from '../api';
import { endpoints } from '../endpoints';

import type { HygieneInsightsResponse } from './types';
import type { GetInsightsRequest } from './useGetBenchmarkingInsightsData';

export const useHygieneInsightsData = (options: GetInsightsRequest) => {
  const { start, end, priorStart, priorEnd, shouldUseMockData } = options;
  const {
    primaryOrganizationId: organizationId,
    primaryPracticeId: practiceId,
  } = useSelector((state: any) => state.login.user);
  const { trackEvent } = useTrackEvent();

  return useQuery<HygieneInsightsResponse>({
    queryKey: [
      'hygiene-insights',
      organizationId,
      start,
      end,
      priorStart,
      priorEnd,
      shouldUseMockData,
    ],
    queryFn: async () => {
      const startTime = performance.now();
      const response = await makeAPIRequestReactQuery<HygieneInsightsResponse>(
        `/${endpoints.videaInsights}/${organizationId}/hygiene-insights`,
        {
          start,
          end,
          priorStart,
          priorEnd,
          returnSampleResponse: shouldUseMockData,
        },
        'get',
        {
          headers: {
            Practice: practiceId,
            Org: organizationId,
          },
        },
      );

      const loadTime = performance.now() - startTime;
      trackEvent(mixpanelEvents.insightsViewLoad, {
        loadTime,
        organizationId,
        practiceId,
        dashboard: 'HYGIENE',
        drilldown: false,
      });

      return response;
    },
    enabled: !!organizationId,
    staleTime: 5 * 60 * 1000,
  });
};
